import { ModulesConfigMap, ModulesMap } from '../data/modulesMaps'

export default {
  getFuelStationGuns: {
    apiServiceMethodName: ModulesConfigMap[ModulesMap.FUEL_STATION_GUNS].GET_FUEL_STATION_GUNS,
  },
  postFuelStationGun: {
    apiServiceMethodName: ModulesConfigMap[ModulesMap.FUEL_STATION_GUNS].POST_FUEL_STATION_GUN,
  },
  getFuelStationGun: {
    apiServiceMethodName: ModulesConfigMap[ModulesMap.FUEL_STATION_GUNS].GET_FUEL_STATION_GUN,
  },
  getFuelStationGunPreview: {
    apiServiceMethodName: ModulesConfigMap[ModulesMap.FUEL_STATION_GUNS].GET_FUEL_STATION_GUN_PREVIEW,
  },
  getFuelStationGunPopup: {
    apiServiceMethodName: ModulesConfigMap[ModulesMap.FUEL_STATION_GUNS].GET_FUEL_STATION_GUN_POPUP,
  },
  putFuelStationGun: {
    apiServiceMethodName: ModulesConfigMap[ModulesMap.FUEL_STATION_GUNS].PUT_FUEL_STATION_GUN,
  },
  patchFuelStationGun: {
    apiServiceMethodName: ModulesConfigMap[ModulesMap.FUEL_STATION_GUNS].PATCH_FUEL_STATION_GUN,
  },
  deleteFuelStationGun: {
    apiServiceMethodName: ModulesConfigMap[ModulesMap.FUEL_STATION_GUNS].DELETE_FUEL_STATION_GUN,
  },
}
